import type { FormValue, Question } from '../../types';
import type { RepeatBindings } from '../primitives/repeatBindings';
import type { LayoutNode } from './types';
import { sumComputedScores } from './computedScore';
import { walkActiveLayoutNodes } from './walkActiveLayoutNodes';

/**
 * Computes all `sum` reductions in layout order; later duplicates of the same `id` overwrite earlier.
 *
 * `conditional` nodes match {@link BespokeLayoutRenderer} `Conditional`: only the active branch is
 * walked so `sum` terms under a hidden branch do not contribute.
 */
export function computeLayoutDerivedTotals(
  nodes: LayoutNode[],
  answers: Record<string, FormValue>,
  repeatBindings: RepeatBindings = {},
  schemaMap?: ReadonlyMap<string, Question>
): Record<string, number> {
  const map: Record<string, number> = {};

  walkActiveLayoutNodes(
    nodes,
    { answers, repeatBindings, derived: map, schemaMap },
    node => {
      if (node.type === 'sum') {
        map[node.id] = sumComputedScores(answers, node.terms);
      }
    }
  );

  return map;
}

/** Vibecode authoring notes for `sum` nodes (empty = omit from LLM bundle). */
export const SUM_VIBECODE =
  '`sum`: weighted terms → `derived[id]`; optional `countWhen:{qid,eq}` on a term.';
